import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32557c8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-order" }
const _hoisted_2 = { class: "confirm-order-content" }
const _hoisted_3 = { class: "confirm-order-title" }
const _hoisted_4 = { class: "confirm-order-text" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "text-rt mt_10 commit" }

import { t } from '@/plugins/i18n'
import { ref, nextTick, toRaw, watch } from 'vue'
import { splitRemindFlagApi } from '@/apis/order'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit }) {


const store = useStore()

const visible = ref(false)
const isAgree = ref(false)
const cancel = () => {
  visible.value = false
}
const commit = () => {
  if (isAgree.value) {
    splitRemindFlagApi({
      customerId: store.state.route.user.customerId
    }).then((res:any) => {
      console.log(res)
      if (res.success) {
        const user = store.state.route.user
        user.splitRemindFlag = 1
        store.commit('route/user', user)
        cancel()
        emit('success')
      }
    })
  } else {
    cancel()
    emit('success')
  }
}
const open = () => {
  visible.value = true
  isAgree.value = false
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": "",
      onClose: cancel,
      draggable: "",
      width: 300
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('下单提醒')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "text",
              innerHTML: _unref(t)('同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货')
            }, null, 8, _hoisted_5),
            _createVNode(_component_el_checkbox, {
              modelValue: isAgree.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgree).value = $event)),
              label: _unref(t)('下次不再提醒')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: commit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('同意')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})